import { Container } from "react-bootstrap";
import Layout from "../../shared/components/Layout";
import Header from "../../shared/components/Header";
import BusinessDetails from "../component/BusinessDetails";


const BusinessIndex = () => {
 
  
  return (
    <Layout>
      <Header title="Manage Business" />
      <Container
        fluid
        className="px-4 py-2"
        style={{
          height: "calc(100vh - 100px)",
          overflowy: "auto",
          overflowX: "hidden",
        }}
      >
       <BusinessDetails  />
       
      </Container>
    </Layout>
  );
};

export default BusinessIndex;
